import { Button, Grid, Paper } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useSelector } from "react-redux";
import CircularLoading from "../../../commons/loading/CircularLoading";
import { StyledRgrl } from "../../../styled/Prevencion";
import DatosDecretoPresentacion from "./lists/DatosDecretoPresentacion";
import DatosEstablecimientoPresentacion from "./lists/DatosEstablecimientoPresentacion";

const PresentacionContainer = ({ handleSubmitForm, isDownloadingPdf }) => {
  const theme = useTheme();
  const datosEstablecimiento = useSelector(
    (state) => state.rgrl.datosEstablecimiento?.data
  );
  const datosDecreto = useSelector((state) => state.rgrl.postRgrl.decretoForm);

  return (
    <StyledRgrl.Paper>
      {!isDownloadingPdf ? (
        <Paper>
          <Grid container>
            <Grid item xs={12}>
              <StyledRgrl.Titulo
                color="primary"
                variant="h5"
              >
                Presentación RGRL
              </StyledRgrl.Titulo>
            </Grid>
            <Grid item container xs={12}>
              <Grid item xs={6} display="flex" justifyContent="center">
                <DatosEstablecimientoPresentacion data={datosEstablecimiento} />
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="center">
                <DatosDecretoPresentacion data={datosDecreto} />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              display="flex"
              justifyContent="center"
              paddingBottom={5}
            >
              <Button
                color="primary"
                variant="contained"
                onClick={() => handleSubmitForm()}
              >
                Finalizar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      ) : (
        <StyledRgrl.LoadingContainer>
          <CircularLoading
            style={{ color: `${theme.palette.tertiary.main}` }}
          />
        </StyledRgrl.LoadingContainer>
      )}
    </StyledRgrl.Paper>
  );
};

export default PresentacionContainer;
